import "./CodiceFiscalePage.css";
import { t } from "../../../services/formatters";
import { useCodiceFiscalePage } from "./useCodiceFiscalePage";
import { Button } from "../../../components/Button";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Riepilogo } from "../../../components/Riepilogo";
import { TextInput } from "../../../components/TextInput";
import { ErrorModal } from "../../../components/ErrorModal";
import { EditAppointmentModal } from "../../../components/EditAppointmentModal";
import { useEffect } from "react";
import { useComponentMetric } from "../../../lib/otel";

export const CodiceFiscaleC5Page = () => {
    const {
        next,
        read,
        onCfChange,
        isDatiUtenteReady,
        isCfFetchStart,
        isCfFetchError,
        getCfInputState,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        showModal,
        closeModal,
        setCodiceFiscale,
        codiceFiscale,
        codiceFiscaleError,
        askForEditAppointment,
        setPrestitoBusiness,
        setPrestitoPersonale,
    } = useCodiceFiscalePage();

const metric = useComponentMetric("codice-fiscale-c5");
    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa3/c5/fissa-appuntamento/codice-fiscale",
            funnelVersion: "nuovo",
            FA_funnel: "Cessione del quinto",
        });
    }, []);

    useEffect(() => {
        if (fetchError) {
            metric.trackError(fetchErrorMessage || "errore verifica codice fiscale");
        }
    }, [fetchError]);


    return (
        <div id="filiali-page">
            <div className={`section page-title-component center-on-tablet`}>
                <h1 dangerouslySetInnerHTML={{ __html: t("c5_titolo") }}></h1>
            </div>

            {/* riepilogo. Rimosso in quanto assente su c5
        {read("filialeScelta") && <Riepilogo />}
      */}

            <div className={`section white-box input-box-component`}>
                <h2>{t("ci_conosciamo")}</h2>
                <p className={`input-box-subtitle`}>&nbsp;</p>
                <TextInput state={getCfInputState()} name="codiceFiscale" placeholder={t("inserisci_cf")} value={read("codiceFiscale")} onChange={onCfChange} maxLength={16} />
            </div>

            <div className="text-center text-small">
                <strong>
                    Prendi visione dell'informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di protezione dei dati
                    personali{" "}
                    <a target="_blank" href="/share/pdfsni/PRIVACY_FA.PDF">
                        <u>qui scaricabile</u>
                    </a>
                </strong>
            </div>

            <div className="section text-center">
                <Button id="go-to-select-state-btn" disabled={!isDatiUtenteReady()} onClick={next} classList="btn-responsive always-style" loading={isCfFetchStart()} text={`${t("avanti")}`} />
            </div>

            <div className="external-products-footer-component">
                <p id="or-text" className="text-center">
                    {t("oppure")}
                </p>

                <div className="section flex-row centered-content text-center">
                    <h4 className="flex-cell clickable">
                        <a
                            onClick={() => {
                                window.location.host.indexOf("compassquinto") != -1 ? (window.location.href = "https://www.compass.it/fa3/") : setPrestitoPersonale();
                                console.log("nuova");
                            }}
                            className="hide-tablet hide-desktop"
                            aria-roledescription="link"
                            aria-label={t("finanziamento_standard")}
                            dangerouslySetInnerHTML={{ __html: t("finanziamento_standard") }}></a>
                        <a
                            onClick={() => {
                                window.location.host.indexOf("compassquinto") != -1 ? (window.location.href = "https://www.compass.it/fa3/") : setPrestitoPersonale();
                                console.log("nuova");
                            }}
                            className="hide-mobile"
                            aria-roledescription="link"
                            aria-label={t("finanziamento_standard")}
                            dangerouslySetInnerHTML={{
                                __html: t("finanziamento_standard"),
                            }}></a>
                    </h4>
                    <h4 className="flex-cell clickable">
                        <a
                            onClick={setPrestitoBusiness}
                            className="hide-tablet hide-desktop"
                            aria-roledescription="link"
                            aria-label={t("finanziamento_business")}
                            dangerouslySetInnerHTML={{ __html: t("finanziamento_business") }}></a>
                        <a
                            onClick={setPrestitoBusiness}
                            className="hide-mobile"
                            aria-roledescription="link"
                            aria-label={t("finanziamento_business")}
                            dangerouslySetInnerHTML={{ __html: t("finanziamento_business") }}></a>
                    </h4>
                </div>

                {/* Edit appto link */}
                <div className="section text-center bottom-area">
                    <div className={`section edit-appointment-link-component text-uppercase color-text-primary clickable`} onClick={askForEditAppointment}>
                        {t("modifica_appuntamento_gia_fissato")}
                    </div>
                </div>
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>

            <EditAppointmentModal open={showModal} title={t("modifica_appuntamento")} text={t("modifica_appuntamento_esistente_unknown_nocf")} onCloseModal={closeModal} />
        </div>
    );
};
